import theme, { colors } from '@/theme';

// global constants

export const COOKIE_KEY_TOKEN = 'fm_auth_token';

export const DEBOUNCE_DELAY = 500;

export const ROUTES = {
  SELECT_FLEET: '/select-fleet',
  OVERVIEW: '/overview',
  DRIVERS: '/drivers',
  DRIVER_STATS: '/driver-details',
  INSURANCE: '/insurance',
  INCIDENTS: '/incidents',
  APP_STATUS: '/app-status',
  DRIVER_PERFORMANCE: '/drivers-performance',
  DRIVER_MANAGEMENT: '/drivers-management',
  EDIT_DRIVERS: '/edit-drivers',
  PROFILE: '/settings/profile',
  MANAGE: '/settings/manage',
  ADVANCED: '/settings/advanced',
  VALIDATOR_TOOL: '/settings/validator-tool',
  LOGIN: '/login',
  TEXT_ME_THE_APP: '/text-me-the-app',
  DRIVER_DETAILS: '/driver-details',
  ADD_DRIVERS: '/add-drivers',
};

export const NAV_HEADERS = {
  [ROUTES.OVERVIEW]: 'Overview',
  [ROUTES.DRIVERS]: 'Drivers',
  [ROUTES.DRIVER_PERFORMANCE]: 'Performance',
  [ROUTES.DRIVER_MANAGEMENT]: 'Management',
  [ROUTES.INSURANCE]: 'Insurance',
  [ROUTES.INCIDENTS]: 'Claims & Incidents',
  [ROUTES.APP_STATUS]: 'Fairmatic App Status',
  [ROUTES.PROFILE]: 'Profile',
  [ROUTES.ADVANCED]: 'Advanced',
  [ROUTES.MANAGE]: 'Manage',
  [ROUTES.TEXT_ME_THE_APP]: 'Text Me The App',
  [ROUTES.DRIVER_DETAILS]: 'Driver Details',
  [ROUTES.VALIDATOR_TOOL]: 'Validator Tool',
  [ROUTES.ADD_DRIVERS]: 'Management',
  [ROUTES.EDIT_DRIVERS]: 'Management',
};

export const COMMON_ROUTES = [
  ROUTES.OVERVIEW,
  ROUTES.DRIVERS,
  ROUTES.DRIVER_STATS,
  ROUTES.INCIDENTS,
  ROUTES.INSURANCE,
  ROUTES.APP_STATUS,
  ROUTES.EDIT_DRIVERS,
  ROUTES.PROFILE,
  ROUTES.ADVANCED,
  ROUTES.VALIDATOR_TOOL,
  ROUTES.TEXT_ME_THE_APP,
  ROUTES.DRIVER_PERFORMANCE,
  ROUTES.DRIVER_MANAGEMENT,
  ROUTES.DRIVER_DETAILS,
  ROUTES.ADD_DRIVERS,
];

export const GRADE_COLORS = {
  excellent: theme.palette.secondary.main,
  good: colors.lightGreen,
  moderate: theme.palette.warning.main,
  coaching: theme.palette.error.main,
};

export const COMPONENTS = {
  DATE_WIDGET: 'DateWidget',
  DATE_FILTER: 'DateFilter',
  LOCATION_FILTER: 'LocationFilter',
  TRIP_PERIODS_FILTER: 'TripPeriodsFilter',
  PERFORMANCE_FILTERS: 'PerformanceFilters',
  TAGS_FILTER: 'TagsFilter',
  DRIVERS_SEARCH: 'DriversSearch',
  PROFILE: 'Profile',
  TAGS_MANAGEMENT: 'TagsManagement',
  FLEET_SUMMARY_REPORT: 'FleetSummaryReport',
  SELECT_FLEET: 'SelectFleet',
  APP_STATUS: 'AppStatus',
  APP_STATUS_CATEGORY_FILTER: 'AppStatusCategoryFilter',
  APP_STATUS_DRIVERS_SEARCH: 'AppStatusDriversSearch',
  ISSUES_TO_RESOLVE: 'IssuesToResolve',
  APP_STATUS_FILTERS: 'AppStatusFilters',
  APP_STATUS_DOWNLOAD: 'AppStatusDownload',
  ADD_DRIVERS_UPLOAD: 'AddDriversUpload',
  DRIVER_INVITE: 'DriverInvite',
  DRIVER_SUMMARY_REPORT: 'DriverSummaryReport',
  EDIT_DRIVERS: 'EditDrivers',
  DRIVERS_MANAGEMENT: 'DriversManagement',
  LOGIN: 'Login',
};

export const ACTIONS = {
  OPEN: 'open',
  UPDATE: 'update',
  SEARCH: 'search',
  SELECTED_DRIVER: 'selected_driver',
  ACCESS_SETTINGS: 'access_settings',
  LOGOUT: 'logout',
  TAG_CREATED: 'tag_create',
  TAG_UPDATED: 'tag_update',
  TAG_DELETED: 'tag_delete',
  DOWNLOAD: 'download',
  SELECT: 'select',
  CLICK: 'click',
  UPLOAD_ATTEMPT: 'upload_attempt',
  UPLOAD_SUCCESS: 'upload_success',
  UPLOAD_ERROR: 'upload_error',
  DOWNLOAD_TEMPLATE: 'download_template',
  ADD_DRIVER_SUCCESS: 'add_driver_success',
  ADD_DRIVER_PARTIAL_FAILURE: 'add_driver_partial_failure',
  ADD_DRIVER_ERROR: 'add_driver_error',
  DISCARD: 'discard',
  PUBLISH_CHANGES: 'publish_changes',
  SHOW_PUBLISH_MODAL: 'show_publish_modal',
  CLOSE_PUBLISH_MODAL: 'close_publish_modal',
  PAGE_CHANGE: 'page_change',
  TAGS_BULK_UPDATED: 'tags_bulk_updated',
  SUBMIT: 'submit',
};

export const CATEGORIES = {
  FILTERS: 'filters',
  NAVIGATION: 'navigation',
  TAGS: 'tags',
  REPORTS: 'reports',
  FLEET: 'fleet',
  PAGE_CHANGE: 'page_change',
  DATA_EXPORT: 'data_export',
  BULK_ACTION: 'bulk_action',
  DATA_MODIFICATIONS: 'data_modifications',
  PAGINATION: 'pagination',
  AUTH: 'auth',
};

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}
